export default "__VITE_ASSET__9780094a__"